<template>
  <div class="scroller">
    <div class="resource">
      <header class="resource__header">
        <h2 class="resource__heading" v-if="action === 'create'">New navigation</h2>
        <h2 class="resource__heading" v-else>Edit navigation</h2>

        <div class="languages">
          <img v-for="(globalLanguage, index) in languages" :key="index" :src="`/static/flags/${globalLanguage.iso}.png`" class="languages__image" @click="changeLanguage(globalLanguage.iso)" :class="{'languages__image--active': language == globalLanguage.iso }">
        </div>
      </header>

      <form class="form" @submit.prevent="onSubmit">
          <div class="grid">
            <div class="grid__column--seven">
              <div class="form__group">
                <label class="form__label" for="title">Title:</label>
                <span class="form__error" v-if="errors.has('title')">{{ errors.first('title') }}</span>
                <input
                  type="text" id="title" name="title"
                  class="form__input" :class="{ 'form__input--error': errors.has('title') }"
                  v-validate="{ required: true }"
                  v-model="navigation.title"
                />
              </div>

              <div class="form__group">
                <label class="form__label" for="title">Structure:</label>
              </div>
              <div class="form__group">
                <DraggableLocal :navigation.sync="navigation.data[language]"/>
                <button type="submit" class="btn btn--primary mt1" v-if="action === 'create'">PUBLISH</button>
                <button type="submit" class="btn btn--primary mt1" v-else>UPDATE</button>
              </div>
            </div>
            <div class="grid__column--five">
                <ul class="scrollBox__header">
                  <li class="scrollBox__type" @click="opened = 'pages'">Pages</li>
                  <li class="scrollBox__type" @click="opened = 'custom'">Custom link</li>
                </ul>
                <div class="scollBox__pages" v-show="opened == 'pages'">
                  <input class="no-margin" type="text" v-model="search" placeholder="Pretraga..."/>
                  <ul class="scrollBox__list">
                    <li class="scrollBox__item" v-for="page in pagesFiltered" :key="page.id">
                      <label class="scrollBox__label">
                        <input type="checkbox" class="scrollBox__checkbox" :value="page" v-model="checkedPages"> {{ page.languages[language].title }}
                      </label>
                    </li>
                  </ul>
                  <button type="button" class="btn btn--primary btn--small mt1" @click="addPages">ADD TO NAVIGATION</button>
                </div>
                <div class="scrollBox__custom" v-show="opened == 'custom'">
                  <label class="form__label" for="title">Title:</label>
                  <input type="text" class="form__input" v-model="custom.title" />

                  <label class="form__label" for="title">URL:</label>
                  <input type="text" class="form__input" v-model="custom.url" />

                  <button type="button" class="btn btn--primary btn--small mt1" @click="addCustomLink">ADD TO NAVIGATION</button>
                </div>
            </div>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
import Navigation from '@/model/Navigation'
import {submitResource} from '@/helpers/handleForm.js'
import DraggableLocal from '@/components/Navigation/DraggableLocal'
import * as types from '@/store/types.js'

export default {
  components: {
    DraggableLocal
  },
  props: {
    action: {
      type: String,
      default: 'edit'
    },
    navigation: {
      type: Object,
      default () {
        return {
          data: {
            hr: [],
            en: []
          }
        }
      }
    },
    pages: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      opened: 'pages',
      custom: {},
      checkedPages: [],
      search: '',
      language: ''
    }
  },
  computed: {
    pagesFiltered () {
      return this.pages.filter((page) => {
        if (page.languages[this.language]) {
          return page.languages[this.language].title.toLowerCase().includes(this.search.toLowerCase())
        }

        return false
      })
    },
    languageGlobal () {
      return this.$store.getters[types.ACTIVE_LANGUAGE]
    },
    languages () {
      return this.$store.getters[types.LANGUAGES]
    }
  },
  methods: {
    addPages () {
      this.checkedPages.forEach((page) => {
        page.url = '/' + page.type.name.toLowerCase() + '/' + page.languages[this.language].url
        page.type = 'Page'
        this.addLink(page)
      })
      this.checkedPages = []
    },
    addCustomLink () {
      this.custom.type = 'Custom'
      this.addLink(this.custom)
    },
    addLink (data) {
      let link = {
        newTab: false,
        title: data.title,
        type: data.type,
        value: data.id,
        url: data.url,
        data: []
      }

      if (data.type === 'Page') {
        link.title = data.languages[this.language].title
      }

      this.navigation.data[this.language].push(link)
    },
    onSubmit () {
      submitResource(this.$validator, Navigation, this.navigation, this.action)
    },
    changeLanguage (language) {
      this.language = language
    }
  },
  created () {
    this.language = this.languageGlobal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navigation/NavigationForm.vue